import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("fx_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(undefined, (error) => {
  const d = error?.response?.data?.detail;
  if (d && typeof d === "object" && !Array.isArray(d)) {
    error.response.data.code = d.code;
    error.response.data.detail = d.message || "Something went wrong.";
    if (d.code === "email_not_verified") {
      window.dispatchEvent(new CustomEvent("fx:email-unverified", { detail: d }));
    }
  }
  return Promise.reject(error);
});

export function setToken(t) {
  if (t) localStorage.setItem("fx_token", t);
  else localStorage.removeItem("fx_token");
}
